export const publicPath = function (env) {
    switch (env) {
      case 'green':
        return 'FieldServiceToolGreen';
      case 'local':
      case 'local-itouat':
        return '';
      default:
        return 'FieldServiceTool';
    }
  };



// WEBPACK FOOTER //
// ./tools/publicPath.js